import _extends from "@babel/runtime-corejs3/helpers/extends";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React from 'react';
import { BaseSelect } from '../internal/base';
import { identity } from 'lodash';

function itemToString() {
  return '';
}

export function Autocomplete(_ref) {
  var _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Type to search' : _ref$placeholder,
      multi = _ref.multi,
      _ref$minChars = _ref.minChars,
      minChars = _ref$minChars === void 0 ? 2 : _ref$minChars,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 200 : _ref$debounce,
      propFilter = _filterInstanceProperty(_ref),
      props = _objectWithoutProperties(_ref, ["placeholder", "multi", "minChars", "debounce", "filter"]);

  var filter = multi ? undefined : identity;
  return /*#__PURE__*/React.createElement(BaseSelect, _extends({}, props, {
    multi: multi,
    placeholder: placeholder,
    filter: filter,
    minChars: minChars,
    debounce: debounce,
    isSearchable: true,
    itemToString: itemToString
  }));
}
export default Autocomplete;